export const renderingHypernovaPayloadName = 'idealist';
